__turbopack_context__.v({
  "chip": "_5l2NqW_chip",
});
